/* eslint-disable */
import * as Blockly from 'blockly';


// GAP_X achicado para igualar la separación visual del legacy (el default de v13 es 24);
// GAP_Y ya coincidía. getWidth() descuenta los 148px del botón de play
// (.bottom-nav-horizontal) porque el scrollbar lee getWidth(), no el width del <svg>: sin
// esto el último bloque de una fila larga queda fuera del viewport.
const HORIZONTAL_FLYOUT_LEFT_INSET = 148;

class JuniorHorizontalFlyout extends Blockly.HorizontalFlyout {
  constructor(workspaceOptions) {
    super(workspaceOptions);
    this.GAP_X = 8;
  }

  getWidth() {
    return Math.max(0, super.getWidth() - HORIZONTAL_FLYOUT_LEFT_INSET);
  }
}

Blockly.registry.register(
  Blockly.registry.Type.FLYOUTS_HORIZONTAL_TOOLBOX,
  'juniorHorizontalFlyout',
  JuniorHorizontalFlyout,
  true,
);

export default JuniorHorizontalFlyout;
